/**
 * User Data Transformer
 * Converts backend snake_case user fields to frontend camelCase
 */

export interface BackendUser {
  id: string;
  email: string;
  full_name?: string;
  is_active: boolean;
  is_admin: boolean;
  email_verified: boolean;
  created_at: string;
  updated_at: string;
  mcp_url?: string;
  username?: string;
}

export interface FrontendUser {
  id: string;
  email: string;
  fullName?: string;
  isActive: boolean;
  isAdmin: boolean;
  emailVerified: boolean;
  createdAt: string;
  updatedAt: string;
  mcpUrl?: string;
  username?: string;
}

/**
 * Transform backend user data to frontend format
 */
export const transformUser = (backendUser: BackendUser): FrontendUser => {
  if (!backendUser) return backendUser as any;
  
  return {
    id: backendUser.id,
    email: backendUser.email,
    fullName: backendUser.full_name,
    isActive: backendUser.is_active,
    isAdmin: backendUser.is_admin,
    emailVerified: backendUser.email_verified,
    createdAt: backendUser.created_at,
    updatedAt: backendUser.updated_at,
    mcpUrl: backendUser.mcp_url,
    username: backendUser.username,
  };
};

/**
 * Transform user in API response
 */
export const transformUserResponse = (response: any): any => {
  if (response?.user) {
    return {
      ...response,
      user: transformUser(response.user),
    };
  }
  return response;
};